var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        inputs: [],
        name: "NewOwnerIsZeroAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NoHandoverRequest",
        type: "error",
    },
    {
        inputs: [],
        name: "Unauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "fromTokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toTokenId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "ConsecutiveTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "pendingOwner",
                type: "address",
            },
        ],
        name: "OwnershipHandoverCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "pendingOwner",
                type: "address",
            },
        ],
        name: "OwnershipHandoverRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "roles",
                type: "uint256",
            },
        ],
        name: "RolesUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "apeMintFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "quantity",
                type: "uint64",
            },
        ],
        name: "apeMintTo",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "apePresaleActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "quantity",
                type: "uint64",
            },
            {
                internalType: "uint256",
                name: "allowed",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "proof",
                type: "bytes32[]",
            },
        ],
        name: "apePresaleMintTo",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "apePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "apeRevenue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "apeSaleActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newMaxAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMaxPerMint",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMaxPerWallet",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newPrice",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "presale",
                type: "bool",
            },
        ],
        name: "apeStartSale",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "apeStopSale",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "apeWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "finalizeApeDrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress_",
                type: "address",
            },
        ],
        name: "initializeApeDrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ApeDropFacet__factory = /** @class */ (function (_super) {
    __extends(ApeDropFacet__factory, _super);
    function ApeDropFacet__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ApeDropFacet__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ApeDropFacet__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ApeDropFacet__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ApeDropFacet__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ApeDropFacet__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    ApeDropFacet__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    ApeDropFacet__factory.bytecode = _bytecode;
    ApeDropFacet__factory.abi = _abi;
    return ApeDropFacet__factory;
}(ContractFactory));
export { ApeDropFacet__factory };
